import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=62128ff9&scoped=true"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"
import style0 from "./LiveChat.vue?vue&type=style&index=0&id=62128ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62128ff9",
  null
  
)

export default component.exports